import { Box, Typography, Stack, Button } from '@mui/material';
import ContentLeft from './ContentLeft';
import ContentRight from './ContentRight';
import classNames from 'classnames/bind';
import Breadcumb from '~/components/Breadcrumb';
import styles from './DetailPost.module.scss';

const cx = classNames.bind(styles);

function DetailPost() {
    return (
        <Box className={cx('DetailPost','container')}>
            <Breadcumb title="Tin tức" slug="Hội thảo khoa học “Giải pháp đa dạng hoạt động phong trào đổi mới sáng tạo" />
            <Box className={cx('content')}>
                <ContentLeft />
                <ContentRight />
            </Box>
        </Box>
    );
}

export default DetailPost;